import { useCreateMutation, useWorkspaceLabels } from '@gripp/shared-logic';
import { StyleSheet, View } from 'react-native';
import { useFormContext } from '../../forms';
import { LabelSelector } from '../../issue/labelSelector';

export const CommonLabel = ({
  workspaceId,
  fieldName,
  title,
  backgroundColor,
}: {
  workspaceId: string;
  fieldName: string;
  title?: string;
  backgroundColor?: string;
}) => {
  const { labels: availableLabels } = useWorkspaceLabels(workspaceId);
  const { mutateAsync: createLabel } = useCreateMutation({
    modelName: 'label',
    query: CREATE_LABEL,
  });
  const { setValue, watch } = useFormContext();

  const handleCreateLabel = async (name: string) => {
    try {
      const result = await createLabel({
        input: { name, workspace: { id: workspaceId } },
      });
      return result;
    } catch (error) {
      console.error('Failed to create label:', error);
      throw error;
    }
  };

  return (
    <View style={[styles.formItem, backgroundColor && { backgroundColor }]}>
      <LabelSelector
        selectedLabels={watch(fieldName) || []}
        availableLabels={availableLabels}
        onLabelsChange={(labels) => {
          setValue(fieldName, labels);
        }}
        onCreateLabel={handleCreateLabel}
        title={title}
        containerBackgroundColor={backgroundColor}
      />
    </View>
  );
};

const CREATE_LABEL = `
  mutation CreateLabel($input: CreateLabelInput!) {
    createLabel(input: $input) {
      id
      name
    }
  }
`;

const styles = StyleSheet.create({
  formItem: {
    marginBottom: 4,
    borderRadius: 8,
  },
});
